import { render } from "./payWithWireTransfer.vue?vue&type=template&id=43677eae&ts=true"
import script from "./payWithWireTransfer.vue?vue&type=script&lang=ts"
export * from "./payWithWireTransfer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__